import { createFileRoute } from '@tanstack/react-router';

import { MyOrdersPage } from '@/features/shop/my-orders-page';

export const Route = createFileRoute('/_app/orders')({ component: MyOrdersPage });
